(function() {
  // Temporary redirect for consolidated Cloak Swivel Drop Leg Holster pages
  const currentPath = window.location.pathname;
  const newUrl = '/products/cloak-swivel-drop-leg-holster';

  // Match patterns: /products/cloak-swivel-drop-leg-holster-for-*, /products/cloak-swivel-drop-leg-for-*, etc.
  // and general wildcard patterns: /products/cloak-swivel-drop-leg-holster-*, /products/cloak-swivel-drop-leg-*
  const redirectPatterns = [
    /^\/products\/cloak-swivel-drop-leg-holster-for-.+$/i,
    /^\/products\/cloak-swivel-drop-leg-for-.+$/i,
    /^\/products\/cloak-swivel-drop-leg-holster-.+$/i,
    /^\/products\/cloak-swivel-drop-leg-.+$/i
  ];

  // Check if current URL matches any redirect pattern
  const shouldRedirect = redirectPatterns.some(pattern => pattern.test(currentPath));

  if (shouldRedirect && currentPath !== newUrl) {
    window.location.replace(newUrl);
  }
})();
